import React from 'react'
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom'
import Main from './main'
import Yes from './routes/Yes'

export default function App() {
  return (
    <Router>
        <Routes>
            <Route exact path="/" element={<Main />} />
            <Route exact path="/HOORAY" element={<Yes />} />
        </Routes>
    </Router>
  );
}